import BaseViewController from "../base-view-controller";
import { FIELD_NAMES } from "../../utils/constants";

const bulletField = {
  name: "bullet",
  title: "•",
  type: "text"
};

const checkIconField = {
  type: "webImage",
  name: "checkIcon",
  image: "ic_check_circle_default"
};

const xIconField = {
  type: "webImage",
  name: "xIcon",
  image: "ic_close_default"
};

class PasswordScreenViewController extends BaseViewController {
  preprocessScreenData() {
    super.preprocessScreenData();
    const { fields, footerFields } = this.screen;

    const atLeastOneLetterCheck = fields.find(
      f => f.name === FIELD_NAMES.lowercaseLetterRequired
    );

    const atLeastOneNumberCheck = fields.find(
      f => f.name === FIELD_NAMES.atLeastOneNumber
    );
    const passwordLengthCheck = fields.find(
      f => f.name === FIELD_NAMES.characterLength
    );
    const passwordConfirmationInput = fields.find(f =>
      f.name.includes("password_confirmation")
    );
    const passwordInputValue = this.appData.values?.password;
    const passwordConfirmationInputValue =
      this.appData.values?.password_confirmation;
    const confirmButton = footerFields[0].fieldLayouts[0].containerFields.find(
      f => f.name.includes("save_button")
    );

    const oneNumberValidation = /[0-9]/.test(this.appData.values?.password);
    const lengthValidation =
      passwordInputValue?.length > 9 && passwordInputValue?.length < 21;
    const oneLetterValidation = /[a-zA-Z]/.test(this.appData.values?.password);
    const allChecksPassed =
      oneLetterValidation && oneNumberValidation && lengthValidation;

    const disableConfirmButton = () => {
      confirmButton.params += "|TDFieldOptionDisabled";
      confirmButton.name += " disabled";
    };
    const enableConfirmButton = () => {
      confirmButton.params = confirmButton.params.replace(
        "|TDFieldOptionDisabled",
        ""
      );
      confirmButton.name = confirmButton.name.replace(" disabled", "");
    };
    const disablePasswordConfirmationInput = () =>
      (passwordConfirmationInput.params += "|TDFieldOptionDisabled");
    const enablePasswordConfirmationInput = () =>
      (passwordConfirmationInput.params =
        passwordConfirmationInput.params.replace("|TDFieldOptionDisabled", ""));

    if (passwordInputValue === undefined || passwordInputValue?.length === 0) {
      atLeastOneNumberCheck.fieldLayouts[0].containerFields[0] = bulletField;
      passwordLengthCheck.fieldLayouts[0].containerFields[0] = bulletField;
      atLeastOneLetterCheck.fieldLayouts[0].containerFields[0] = bulletField;

      if (!passwordConfirmationInput.params.includes("TDFieldOptionDisabled")) {
        disablePasswordConfirmationInput();
      }

      if (confirmButton.name === "save_button") {
        disableConfirmButton();
      }
      return;
    }

    if (oneNumberValidation) {
      atLeastOneNumberCheck.fieldLayouts[0].containerFields[0] = checkIconField;
    } else {
      atLeastOneNumberCheck.fieldLayouts[0].containerFields[0] = xIconField;
    }

    if (lengthValidation) {
      passwordLengthCheck.fieldLayouts[0].containerFields[0] = checkIconField;
    } else {
      passwordLengthCheck.fieldLayouts[0].containerFields[0] = xIconField;
    }

    if (oneLetterValidation) {
      atLeastOneLetterCheck.fieldLayouts[0].containerFields[0] = checkIconField;
    } else {
      atLeastOneLetterCheck.fieldLayouts[0].containerFields[0] = xIconField;
    }

    if (allChecksPassed) {
      enablePasswordConfirmationInput();
    } else if (
      !passwordConfirmationInput.params.includes("TDFieldOptionDisabled")
    ) {
      disablePasswordConfirmationInput();
    }

    if (passwordInputValue === passwordConfirmationInputValue) {
      enableConfirmButton();
    } else if (confirmButton.name === "save_button") {
      disableConfirmButton();
    }
  }

  handleButtonClick(
    name,
    text,
    action,
    replaceHistory,
    initialScreen,
    eventStates
  ) {
    super.handleButtonClick(
      name,
      text,
      action,
      replaceHistory,
      initialScreen,
      eventStates
    );

    if (name === "save_button") {
      this.appData.prevScreen();
    }
  }
}

export default PasswordScreenViewController;
